import { render, staticRenderFns } from "./PeriodicReports.vue?vue&type=template&id=4a3f2d69"
import script from "./PeriodicReports.vue?vue&type=script&lang=js"
export * from "./PeriodicReports.vue?vue&type=script&lang=js"
import style0 from "./PeriodicReports.vue?vue&type=style&index=0&id=4a3f2d69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports